import heroVideo from "../assets/case-studies/qr-pay/hero.mp4";
import heroPoster from "../assets/case-studies/qr-pay/hero.webp";
import workflow from "../assets/case-studies/qr-pay/workflow.webp";
import workflowPreview from "../assets/case-studies/qr-pay/workflow-1118.webp";
import problemWait from "../assets/case-studies/qr-pay/problem-wait.webp";
import problemWaitDark from "../assets/case-studies/qr-pay/problem-wait-dark.webp";
import document from "../assets/case-studies/qr-pay/document.webp";
import outcome from "../assets/case-studies/qr-pay/outcome.webp";
import askReceipt from "../assets/case-studies/qr-pay/ask-receipt.webp";
import copyHumanizing from "../assets/case-studies/qr-pay/copy-humanizing.webp";
import explore01 from "../assets/projects/qr-explorations/01-initial.webp";
import explore02 from "../assets/projects/qr-explorations/02-percent-cards.webp";
import explore03 from "../assets/projects/qr-explorations/03-percent-grid.webp";
import explore04 from "../assets/projects/qr-explorations/04-keypad-plus-minus.webp";
import explore05 from "../assets/projects/qr-explorations/05-slider.webp";
import explore06 from "../assets/projects/qr-explorations/06-keypad-inline.webp";
import explore07 from "../assets/projects/qr-explorations/07-keypad-centered.webp";
import explore08 from "../assets/projects/qr-explorations/08-dual-stepper-summary.webp";
import explore09 from "../assets/projects/qr-explorations/09-preset-chips.webp";
import explore10 from "../assets/projects/qr-explorations/10-preset-chips-tall.webp";
import explore11 from "../assets/projects/qr-explorations/11-keypad-stacked.webp";
import explore12 from "../assets/projects/qr-explorations/12-slider-dual-stepper.webp";
import explore13 from "../assets/projects/qr-explorations/13-dual-stepper-paid.webp";
import explore14 from "../assets/projects/qr-explorations/14-progress-dual-stepper.webp";
import scenario04 from "../assets/projects/qr-scenarios/04-before-nora-taps.webp";
import scenario01 from "../assets/projects/qr-scenarios/01-pays-in-full.webp";
import scenario02 from "../assets/projects/qr-scenarios/02-first-to-scan.webp";
import scenario03 from "../assets/projects/qr-scenarios/03-pay-in-parallel.webp";
import scenario05 from "../assets/projects/qr-scenarios/05-one-portion-before.webp";
import scenario06 from "../assets/projects/qr-scenarios/06-two-portions-before.webp";
import scenario07 from "../assets/projects/qr-scenarios/07-paying-in-full.webp";
import scenario08 from "../assets/projects/qr-scenarios/08-paying-for-two.webp";
import scenario09 from "../assets/projects/qr-scenarios/09-closes-mid-payment.webp";
import scenario10 from "../assets/projects/qr-scenarios/10-closes-after-payment.webp";
import scenario11 from "../assets/projects/qr-scenarios/11-after-paid.webp";
import scenario12 from "../assets/projects/qr-scenarios/12-server-error.webp";

const otherScenarios = [
  { src: scenario01, alt: "Scans QR and pays in full" },
  { src: scenario02, alt: "First to scan QR and pay for 2" },
  { src: scenario03, alt: "Second to scan QR, and they pay in parallel" },
  { src: scenario05, alt: "James pays for 1 person before Austin taps" },
  { src: scenario06, alt: "James pays for 2 people before Austin taps" },
  { src: scenario07, alt: "James is paying in full while Nora scans" },
  { src: scenario08, alt: "James is paying for 2 while Austin scans" },
  { src: scenario09, alt: "Closes the browser mid-payment, then scans again" },
  { src: scenario10, alt: "Closes the browser after payment, then scans again" },
  { src: scenario11, alt: "Scans QR after the check is paid" },
  { src: scenario12, alt: "Scans QR and gets a server error" },
];

const splitExplorationGallery = {
  /* Same viewer as the stakeholder scenarios: big phone + thumbnail strip */
  variant: "carousel",
  label: "exploration",
  itemWidth: 750,
  itemHeight: 1624,
  stageAspect: "16 / 10",
  caption: "Exploring different ways to split a check",
  items: [
    {
      src: explore01,
      alt: "Split Check initial state with total and per-person amounts",
    },
    { src: explore02, alt: "Split Check percentage preset cards exploration" },
    {
      src: explore03,
      alt: "Split Check dense percentage card grid exploration",
    },
    { src: explore04, alt: "Split Check keypad with plus and minus controls" },
    { src: explore05, alt: "Split Check slider input exploration" },
    { src: explore06, alt: "Split Check inline keypad with side buttons" },
    { src: explore07, alt: "Split Check centered keypad amount entry" },
    {
      src: explore08,
      alt: "Split Check dual quantity steppers with cost summary",
    },
    { src: explore09, alt: "Split Check preset amount chips exploration" },
    { src: explore10, alt: "Split Check tall preset chips with Add Other" },
    { src: explore11, alt: "Split Check stacked totals with numeric keypad" },
    { src: explore12, alt: "Split Check progress slider with dual steppers" },
    {
      src: explore13,
      alt: "Split Check dual steppers with partial payment state",
    },
    {
      src: explore14,
      alt: "Split Check progress bar with dual quantity steppers",
    },
  ],
};

export const qrPayCaseStudy = {
  slug: "qr-pay",
  editorialMedia: true,
  motion: true,
  chrome: "meadow",
  paintTheme: "qr",
  headerVariant: "qr",
  /* Self-playing HTML film of the Split Check flow (src/components/QrPayFilm) */
  headerFilm: true,
  headerLayout: "stacked",
  headerImage: heroVideo,
  headerPoster: heroPoster,
  /* Landing indigo paint; keep wash asset as soft alternate underpaint */
  headerAnimated: true,
  /* Video + chroma so the baked-in crimson mat keys out against the header */
  headerMediaType: "video",
  headerChromaKey: "#a61c1c",
  headerChromaTolerance: 56,
  headerChromaSpill: 96,
  headerMediaRate: 1.75,
  title: [
    "Redesigned Oracle QR Pay to reduce",
    "checkout friction and speed up table turns",
  ],
  titleAccent: "speed up table turns",
  metaLayout: "facts",
  meta: {
    company: "Oracle",
    role: "UX designer",
    team: ["PM", "Engineering"],
    duration: "2 months",
    year: "2023",
  },
  /* Highlights live later in the story — not between TL;DR and Problem in Figma */
  highlights: [],
  sections: [
    {
      type: "problem-figure",
      label: "Problem",
      title:
        "Tables were waiting on a busy server to split the check",
      figure: {
        src: problemWait,
        darkSrc: problemWaitDark,
        alt: "Stick-figure diners waiting while a busy server walks past with a full tray",
        role: "full",
        interactive: false,
      },
    },
    {
      type: "ask-split",
      label: "Why",
      title: "The ask was Split Check, but guests needed more than that",
      paragraphs: [
        "I joined Phase 2 of Oracle QR Pay with a specific ask: add Split Check so guests could pay their share from their phones, without waiting on a server.",
        "QR Pay prints a QR code on the guest check. Diners scan it and pay in their browser, with no app, and the check closes automatically in the POS.",
        "Nobody asked me to look at the rest of the checkout. But a split only helps if guests understand what they’re paying, so I audited the existing flow on my own. What I found changed the scope of the project.",
      ],
      figure: {
        src: askReceipt,
        alt: "Oracle QR Pay check with the new Split Check option above Pay Full",
        crop: "bottom",
        width: 754,
        height: 1290,
      },
    },
    {
      type: "content",
      label: "Audit",
      title: "Guests could miss the service charge, so I made the case for a redesign",
      paragraphs: [
        "The automatic service charge was easy to miss when reviewing a payment, and usability testing with 5 users verified it. Nobody wants a surprise on the bill at the end of a meal, and adding a split would spread that confusion across the whole table.",
        "A clearer checkout would also help guests pay and leave, so restaurants could turn tables sooner. With limited capacity and a fixed deadline, that still wasn’t an easy ask. I showed the PM and engineers side-by-side comparisons of what guests saw, and framed the redesign as an investment in reducing future rework, not a visual refresh. We agreed to tackle both.",
      ],
      figure: {
        component: "qr-charge-compare",
        caption: "The same $138.00 payment, before and after.",
      },
    },
    {
      type: "rich",
      label: "Research",
      title: "Guests already know how payment apps work, so I started there",
      blocks: [
        {
          type: "paragraph",
          text: "I used other payment apps as a baseline for check details, tipping, splitting, and the moment after payment.",
        },
        { type: "figure", figure: { component: "qr-benchmark" } },
      ],
    },
    {
      type: "rich",
      label: "Exploration",
      title: "I explored 14 ways to split a bill and chose two steppers",
      blocks: [
        {
          type: "paragraph",
          text: "The team had settled on even splits for this phase, and I tried other approaches alongside them. I chose two steppers: how many people are sharing the bill, and how many you’re paying for. A few taps replaced mental math at the table.",
        },
        {
          type: "paragraph",
          text: "I explored the UX copy alongside the interaction, because it had to make sense mid-conversation at the table.",
        },
        {
          type: "thumbs",
          items: splitExplorationGallery.items,
          caption: "14 ways I explored splitting a check. Select one to enlarge it.",
        },
        { type: "figure", figure: { component: "qr-chosen-split" } },
      ],
    },
    {
      type: "rich",
      title: "Guests wanted to pay, know they were done, and leave",
      blocks: [
        {
          type: "paragraph",
          text: "I assumed guests would want to know what was still owed, so I first explored a progress indicator.",
        },
        {
          type: "paragraph",
          text: "I tested the Figma prototype with 6 participants, asking them to split a check and pay their share. They preferred a clear confirmation that their own payment was complete, so I removed the indicator.",
        },
        { type: "figure", figure: { component: "qr-usability-finding" } },
      ],
    },
    {
      type: "content",
      bg: "tint",
      label: "Constraints",
      title: "To cut taps, I had to understand the payment system",
      paragraphs: [
        "I wanted guests to tip, review the total, and pay in as few taps as possible. I needed to understand the payment system itself, not just the screens, so I mapped the end-to-end workflow with developers.",
      ],
    },
    {
      type: "rich",
      bg: "tint",
      title: "The amount had to lock before payment, so tip and pay stayed separate",
      blocks: [
        {
          type: "paragraph",
          text: "That showed me why fewer taps weren’t possible. The amount had to be locked and sent to Adyen before payment, so tip and pay couldn’t share a page. I gave up the shorter flow and kept them apart.",
        },
        {
          type: "figure",
          figure: {
            src: workflow,
            alt: "Oracle QR Pay workflow diagram",
            caption: "The end-to-end payment workflow, mapped with developers.",
            role: "diagram",
            expandInline: true,
            previewSrc: workflowPreview,
            previewWidth: 1118,
            width: 3606,
            height: 4096,
          },
        },
        { type: "figure", figure: { component: "qr-flow-shift" } },
      ],
    },
    {
      type: "rich",
      title: "The map also showed where payments could fail",
      blocks: [
        {
          type: "paragraph",
          text: "The system couldn’t reliably show who had paid or update balances in real time. Closing the browser mid-payment could leave a payment hold unresolved. And Adyen owned the payment interface, limiting what we could change.",
        },
        {
          type: "paragraph",
          text: "I couldn’t remove those limits, but guests shouldn’t be left guessing. So I mapped edge cases like simultaneous payments and interrupted transactions, and wrote clear, actionable messages for each state.",
        },
        {
          type: "figure",
          figure: {
            src: copyHumanizing,
            alt: "Four pop-up messages: someone at your table already split the check, check balance has changed, payment in progress, and sorry, we are unable to process your payment",
            caption: "The messages guests see, each with a clear next step.",
            role: "screen-grid",
          },
        },
      ],
    },
    {
      type: "rich",
      title: "Edge cases are hard to picture, so I told them as a story",
      blocks: [
        {
          type: "paragraph",
          text: "To bring non-technical stakeholders in, I built a prototype around a group of four friends splitting a check. Each scenario showed one edge case, like paying at the same time or closing the browser mid-payment.",
        },
        {
          type: "scenario-story",
          featured: { src: scenario04, alt: "James splits the check just before Nora taps" },
          others: otherScenarios,
        },
      ],
    },
    {
      type: "content",
      label: "Final design",
      title: "The service charge now sits where guests decide to pay",
      paragraphs: [
        "I moved the payment breakdown beside the Continue button and styled it like a receipt, so the total and service charge are easy to review before paying.",
      ],
      figure: { component: "qr-final-flow" },
    },
    {
      type: "content",
      title: "Item-level splitting waited for the next phase",
      paragraphs: [
        "This phase shipped even splits, with item-level splitting and other enhancements documented for later. I wrote up what we learned and clear recommendations for the next phase.",
      ],
      figures: [
        {
          src: document,
          alt: "Recommendations and next steps documentation",
          caption: "Recommendations and next steps documented for future phases.",
          role: "document",
        },
      ],
    },
    {
      type: "outcome-split",
      label: "Outcome",
      title: "Split Check shipped on time, and the redesign shipped with it",
      paragraphs: [
        "Taking on both didn’t cost us the deadline. Guests got a way to split the check, and a checkout that shows them what they’re paying.",
      ],
      bullets: [
        { lead: "Shipped on time:", text: "Split Check launched with the redesigned payment experience, within a fixed deadline." },
        { lead: "Clearer costs:", text: "Guests can review the service charge and full total before they pay." },
        { lead: "Clearer failures:", text: "Payment errors and interrupted transactions now come with a clear next step." },
        { lead: "Ready for what’s next:", text: "I documented recommendations so the next phase could pick up where I left off." },
      ],
      figure: {
        src: outcome,
        alt: "Oracle QR Pay with Split Check on client device",
        caption:
          "One of the early Oracle clients where QR Pay with Split Check shipped.",
        role: "outcome",
        outcomeCard: true,
      },
    },
    {
      type: "rich",
      label: "With AI",
      title: "With AI today, I’d test a live prototype and design for client branding",
      blocks: [
        {
          type: "paragraph",
          text: "This project was in 2023. With AI, I’d explore faster, replace the Figma prototype with a live one, and build for client branding from the start.",
        },
        {
          type: "goal-map",
          heads: ["What I did then", "What I’d do with AI now"],
          rows: [
            {
              goal: "Explored 14 ways to split a check",
              change: "Explore faster, so I could compare more directions",
            },
            {
              goal: "Tested with a Figma prototype",
              change: "Build a live prototype for testing",
            },
            {
              goal: "Walked stakeholders through a prototype",
              change: "Use the same live prototype for stakeholder review",
            },
            {
              goal: "Designed one Oracle-branded experience",
              change: "Design one that can use each client’s branding system",
            },
          ],
        },
        { type: "figure", figure: { component: "qr-brand-themes" } },
      ],
    },
    {
      type: "reflection",
      label: "Takeaways",
      title: "What I learned building Oracle’s QR Pay",
      takeaways: [
        {
          title: "Advocate for the user, even when the ask is narrower",
          body: "The request was one feature, but guests needed more. Evidence from the audit and a clear case for the business got the team behind a redesign.",
        },
        {
          title: "Test assumptions before committing to them",
          body: "The progress indicator I expected users to value wasn’t needed, so I changed direction based on what participants showed me.",
        },
        {
          title: "Design with the system, not just the screens",
          body: "Mapping the workflow with engineering helped me account for constraints and edge cases before handoff.",
        },
      ],
    },
  ],
};
